import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Save } from "lucide-react";
import { toast } from "sonner";

const FIELDS = [
  { key: "ga4_id", label: "GA4 Measurement ID", ph: "G-XXXXXXX" },
  { key: "gtm_id", label: "Google Tag Manager ID", ph: "GTM-XXXXXXX" },
  { key: "google_ads_id", label: "Google Ads ID", ph: "AW-XXXXXXX" },
  { key: "google_ads_conversion_label", label: "Google Ads conversion label" },
  { key: "search_console_verify", label: "Search Console verification code" },
  { key: "meta_pixel_id", label: "Meta Pixel ID" },
  { key: "fb_domain_verify", label: "Facebook Domain Verification" },
  { key: "linkedin_id", label: "LinkedIn Insight ID" },
];

const SCRIPTS = [
  { key: "custom_header", label: "Custom header scripts (<head>)" },
  { key: "custom_body", label: "Custom body scripts" },
  { key: "custom_footer", label: "Custom footer scripts" },
];

export default function Tracking() {
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/admin/settings").then((r) => setS(r.data)); }, []);
  if (!s) return <div>Loading…</div>;

  const t = s.tracking || {};
  const setT = (k, v) => setS((p) => ({ ...p, tracking: { ...(p.tracking || {}), [k]: v } }));

  const save = async () => {
    setSaving(true);
    try { await api.put("/admin/settings", s); toast.success("Tracking saved"); }
    catch { toast.error("Save failed"); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500">Tracking & Integrations</div>
          <h1 className="font-display text-4xl mt-3">Connect your tools</h1>
          <p className="text-sm text-zinc-500 mt-2 max-w-xl">Add Google, Meta and LinkedIn tracking IDs. Scripts load on the public site and stay off the admin pages.</p>
        </div>
        <button onClick={save} disabled={saving} className="inline-flex items-center gap-2 bg-zinc-900 text-white px-4 py-2 text-sm rounded-md" data-testid="tracking-save">
          <Save className="w-4 h-4" /> {saving ? "Saving…" : "Save"}
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-10 max-w-4xl">
        {FIELDS.map((f) => (
          <div key={f.key}>
            <label className="text-xs uppercase tracking-wider text-zinc-500">{f.label}</label>
            <Input value={t[f.key] || ""} onChange={(e) => setT(f.key, e.target.value)} placeholder={f.ph || ""} className="mt-2" data-testid={`tracking-${f.key}`} />
          </div>
        ))}
      </div>

      <div className="mt-10 space-y-6 max-w-4xl">
        {SCRIPTS.map((f) => (
          <div key={f.key}>
            <label className="text-xs uppercase tracking-wider text-zinc-500">{f.label}</label>
            <Textarea value={t[f.key] || ""} onChange={(e) => setT(f.key, e.target.value)} rows={5} className="mt-2 font-mono text-xs" data-testid={`tracking-${f.key}`} placeholder="<script>…</script>" />
          </div>
        ))}
      </div>
    </div>
  );
}
